import { TableFilterStateType } from "utils/types";

export function getTableParams(tableState: TableFilterStateType | { [key: string]: any } = {}) {
    let params: any = {
        page: 1,
        pageSize: 20
    }

    if (tableState.page) {
        params = {
            ...params,
            page: tableState.page
        }
    }

    if (tableState.pageSize) {
        params = {
            ...params,
            pageSize: tableState.pageSize
        }
    }

    if (tableState.sortKey && tableState.sortType) {
        params = {
            ...params,
            sortOrder: [
                {
                    member: tableState.sortKey,
                    sortDirection: tableState.sortType === "asc" ? 0 : 1
                }
            ]
        }
    } else {
        params = {
            ...params,
            sortOrder: [
                {
                    member: "id",
                    sortDirection: 1
                }
            ]
        }
    }

    if (tableState.searchColumnFilters?.length) {
        params = {
            ...params,
            searchColumnFilters: tableState.searchColumnFilters
        }
    }

    if (tableState.columnFilter?.length) {
        params = {
            ...params,
            customFilters: tableState.columnFilter
        }
    }


    if (tableState.extraFilter) {
        params = {
            ...params,
            extraFilter: tableState.extraFilter
        }
    }

    return params;
}